module.exports = __webpack_public_path__ + "media/newstyle/images/Componente 8 – 2-2c920f94b9eb9fd0fc777ffacc672fb2.svg";